module.exports = {"publisher":"Publisher: ","certificate":"Received certificate","noData":"Subject does not hold any certificates"}